import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STTypeComponent from "../../../api/StationaryTesting/STType";
import STTypeForm from "./STTypeForm";
import { getMessage } from "../../../global";
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});


const STType = (props) => {

    const initialStateType = {
        id: undefined,
        typeName: "",
        description: "",
        isActive: false,
    };

    const validationsInitialState =
    {
        typeName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateType);
    const [typeList, setTypeList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveType();
            else {

                STTypeComponent.get(infoData.typeName).then((typeExists) => {
                    if ((typeExists !== undefined && typeExists !== null))
                        openModalSimpleButton('Fail', 'This ST Type name already exist', 'Ok');
                    else saveType();
                });
            }
        }
    }

    function saveType() {

        let type = new STTypeComponent({
            typeName: infoData.typeName,
            isActive: infoData.isActive,
            description: infoData.description
        });

        if (infoData.id === undefined) {
            STTypeComponent.add(type).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'ST Type saved with success', 'Ok');
                    loadTypeFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STTypeComponent.update(type).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'ST Type updated with success', 'Ok');
                    loadTypeFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadTypeFilter() {
        STTypeComponent.getAll().then((res) => {
            if (res.length > 0) {

                let array = [];
                array.push({ id: undefined, typeName: "" });
                array.push(...res);

                setTypeList(array);
            }
        });
    }

    function validateFields() {
        let requiredTypeName = infoData.typeName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            typeName: requiredTypeName
        });

        return ((requiredTypeName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateType);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTTypeFilter(idSelected) {
        setInfoData(initialStateType);

        setInfoData(() => ({
            ...initialStateType,
            id: idSelected,
            typeName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STTypeComponent.get(idSelected).then((type) => {
                if (type !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        typeName: type.typeName,
                        description: type.description,
                        isActive: type.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (typeList === null) {
            loadTypeFilter();
        }
    }, [typeList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading ST Type..."}
                                        value={infoData.typeName === '' ? null : infoData.typeName}
                                        onChange={(e, value) => {
                                            handleChangeSTTypeFilter(value);
                                        }}
                                        disablePortal
                                        options={typeList ? typeList.map((type) => type.typeName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="ST Type" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STTypeForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTTypeFilter={handleChangeSTTypeFilter}
                            canEdit={canEdit}
                        >
                        </STTypeForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STType;